import type { ReactElement } from 'react';
import type { MediaDto } from '@gr/core/content/media/dto';
import { Link, useT } from '../../../../app/di';
import { MediaThumb } from '../MediaThumb/MediaThumb';
import styles from './MediaTile.module.scss';

/** Плитка библиотеки: превью, имя файла, заметка или где используется. */
export function MediaTile({ media }: { media: MediaDto }): ReactElement {
  const { tp } = useT();
  return (
    <Link to="mediaItem" params={{ blogId: media.blogId, mediaId: media.id }} className={styles.tile}>
      <MediaThumb media={media} />
      <span className={styles.name} title={media.originalName}>
        {media.originalName}
      </span>
      <span className={styles.caption}>{media.note || (media.usedInPostCount > 0 ? tp('media.library.usedIn', media.usedInPostCount) : ' ')}</span>
    </Link>
  );
}
